import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة خمس المبلغ - حساب خمس المبلغ بناءً على المبلغ الكلي";
const DESCRIPTION =
  "حاسبة خمس المبلغ تقوم بحساب خمس المبلغ بناءً على المبلغ الكلي المدخل.";
const KEYWORDS = "خمس المبلغ, حساب خمس المبلغ, حاسبة خمس المبلغ";
const OG_URL = "https://do-calculate.com/calculator/ar/one-fifth";
function Calculator() {
  const [totalAmount, setTotalAmount] = useState("");
  const [oneFifthAmount, setOneFifthAmount] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!totalAmount) {
      setError("الرجاء إدخال المبلغ الكلي");
      setOneFifthAmount("");
      return;
    }
    const amountValue = parseFloat(totalAmount);
    if (isNaN(amountValue) || amountValue <= 0) {
      setError("الرجاء إدخال قيمة صحيحة وموجبة للمبلغ الكلي");
      setOneFifthAmount("");
      return;
    }
    const oneFifth = amountValue / 5;
    setOneFifthAmount(oneFifth.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>كيفية حساب خمس المبلغ </h2>
                <p>
                  لحساب خمس المبلغ، يجب عليك إدخال المبلغ الكلي المراد حساب
                  خمسه. ثم سيتم حساب خمس المبلغ ببساطة بقسمة المبلغ الكلي على
                  العدد 5.
                </p>
                <p>خمس المبلغ = المبلغ الكلي / 5</p>
                <p>
                  يمكنك استخدام هذه الحاسبة لحساب خمس المبلغ بناءً على المبلغ
                  المُدخل.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">المبلغ الكلي</label>
                      </b>
                      <input
                        type="number"
                        placeholder="المبلغ الكلي"
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب خمس المبلغ
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {oneFifthAmount !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            خمس المبلغ: {oneFifthAmount}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default Calculator;
